import { ContainerModule } from 'inversify';
import ConfigFactory from './ConfigFactory';
import CreditflowConfigFactory from '@creditflowresearch/config/DI/ConfigFactory';
import { TYPES } from '@/Framework/config/DI/types';
import { DomainConfig } from '@/Framework/config/DI/DomainConfig';

export const configModules = new ContainerModule((bind) => {
  bind(TYPES.AppConfig).toDynamicValue(({ container }) => {
    const hostname = container.get<string>(TYPES.Hostname);
    const domain = container.get<DomainConfig>(TYPES.DomainConfig);

    const factory = hostname.includes('creditflowresearch')
      ? new CreditflowConfigFactory(domain)
      : new ConfigFactory(domain);

    return factory.create();
  }).inSingletonScope();
});
